<!-- <ul class="social list-unstyled d-flex my-2">
  <li class="flexCenter rounded-circle me-2 cPointer flex-shrink-0">
    <a class="text-decoration-none text-black" href=""
      ><i class="fa-brands fa-facebook-f"></i
    ></a>
  </li>
  <li class="flexCenter rounded-circle me-2 cPointer flex-shrink-0">
    <a class="text-decoration-none text-black" href=""
      ><i class="fa-brands fa-twitter"></i
    ></a>
  </li>
  <li class="flexCenter rounded-circle me-2 cPointer flex-shrink-0">
    <a class="text-decoration-none text-black" href=""
      ><i class="fa-brands fa-linkedin-in"></i
    ></a>
  </li>
  <li class="flexCenter rounded-circle me-2 cPointer flex-shrink-0">
    <a class="text-decoration-none text-black" href=""
      ><i class="fa-brands fa-instagram"></i
    ></a>
  </li>
</ul> -->

<ul class="social list-unstyled d-flex flex-wrap my-2">
  <li
    *ngFor="let link of socialLinks"
    class="flexCenter rounded-circle me-2 mb-2 cPointer flex-shrink-0"
  >
    <a
      class="text-decoration-none text-black"
      [href]="link.url"
      target="_blank"
      rel="noopener"
    >
      <i class="fa-brands" [ngClass]="getIconClass(link.type)"></i>
    </a>
  </li>
</ul>
